import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend, { HttpBackendOptions } from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

i18n.use(LanguageDetector)
    .use(HttpBackend)
    .use(initReactI18next)
    .init<HttpBackendOptions>({
        lng: 'en',
        fallbackLng: 'en',
        defaultNS: 'webeoc-downloads',
        detection: {
            order: ['localStorage'],
        },
        interpolation: {
            escapeValue: false,
        },
        react: {
            useSuspense: false,
        },
        backend: {
            loadPath: 'locales/{{lng}}/{{ns}}.json',
            queryStringParams: { v: '' + __BUILD_TIMESTAMP__ },
        },
    });

i18n.on('languageChanged', (lng) => document.documentElement.setAttribute('lang', lng));

export default i18n;
